import styled from 'styled-components'

export const Login = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background: url("/thor-assets/background-black.svg") #1d1d1c;
    background-size: cover;
    background-repeat: no-repeat;
`

export const Title = styled.div`
    font-family: "Gotham-Bold", sans-serif;
    color: #fff;
    font-size: 26px;
    margin-bottom: 60px;
    text-align: center;
`

export const Form = styled.form`
    background-color: #e6b01c;
    position: relative;
    border-radius: 3px;
    max-width: 300px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const Entry = styled.div`
    display: flex;
    align-items: center;
    padding: 5px;
    width: 100%;
    flex: 1;

    label {
        padding: 0 10px 0;
        flex: 1;
        text-align: right;
        cursor: pointer;
    }

    input {
        padding: 5px;
        border: none;
        border-radius: 3px;
        outline: none;

        @media (max-width: 550px) {
            font-size: 16px;
        }
    }
`

export const Button = styled.button`
    border: 2px solid #000;
    border-radius: 5px;
    font-weight: 600;
    display: block;
    margin-top: 1em;
    padding: 10px 15px;
    background: #000;
    color: #fff;
    text-transform: uppercase;
    cursor: pointer;
`

export const Error = styled.div`
    width: 80%;
    padding: 10px;
    border: 1px solid #d9534f;
    border-left-width: 5px;
    border-radius: 5px;
    border-left-color: #d9534f;
    background-color: #efbbb9;
    margin-top: 10px;

    & strong {
        color: #d9534f;
    }
`